// extracted by mini-css-extract-plugin
export default {"title":"styles_title__okJWd","subTitle":"styles_subTitle__wsbPy","backicon":"styles_backicon__rSj-p"};